import { render, staticRenderFns } from "./ParentsDead.vue?vue&type=template&id=7ce07f4b&scoped=true"
import script from "./ParentsDead.vue?vue&type=script&lang=js"
export * from "./ParentsDead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce07f4b",
  null
  
)

export default component.exports